import { $LOADER, $PAGE } from "~/util/Loaders";
import { useT, useTurl } from "~/util/Lang";
import { Breadcrumb } from "~/components/ui/Breadcrumb";
import { PageTitle } from "~/components/ui/PageTitle";
import { homePage } from "~/util/titles";
import css from "./home.module.css";
import { Link } from "react-router";
import { logPageView } from "~/util/stats";

$PAGE({
  path: "hud",
  loader: $LOADER?.(async (cx) => {
    // Log
    logPageView(cx);
    //
    return { authUser: cx.req.sess?.user };
  }),
  meta: (cx) => {
    const title = "L2hub HUD";

    return {
      title: `${title} - ${homePage(cx.realm)}`,
      description: "L2hub HUD",
    };
  },
  render: () => {
    const t = useT();
    const turl = useTurl();
    const title = `L2hub HUD`;
    return (
      <div className="content">
        <div className={css.root}>
          <div className="columns">
            <div className="column is-three-quarters">
              <Breadcrumb items={[{ title, url: turl("/hud") }]} />
              <PageTitle>{title}</PageTitle>
              <p>
                {t({
                  en: "L2hub HUD is an app that shows an overlay on top of the Lineage 2 game window. For example, it shows drop and spoil lists for selected target.",
                  ru: "L2hub HUD — это приложение, которое показывает информацию прямо внутри игры Lineage 2. Например, оно позволяет смотреть дроп и спойл с монстра в таргете.",
                })}
              </p>
              <iframe
                width="720"
                height="480"
                src="https://www.youtube.com/embed/EGNRi72WUq4?si=e8YoiAsD7iGe8EoV"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              ></iframe>

              <h2>Features:</h2>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/buff_timer.png"
                  alt="Lineage 2 Buff Timer"
                />
                <div>
                  <h3 id="buff_timer">Buff/Debuff Timer</h3>

                  <p>
                    {t({
                      en: "Adds a buffs panel with a timer.",
                      ru: "Панель бафов с таймером.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img src="/s/hud/icons/npc_info.png" alt="Lineage 2 Npc Info" />
                <div>
                  <h3 id="npc_info">NPC Info</h3>
                  <p>
                    {t({
                      en: "Level, HP/MP, EXP/SP, Vulnerabilities, Drop and Spoil",
                      ru: "Показывает информацию о НПЦ (Level, HP/MP, EXP/SP) с дропом и спойлом.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/market.png"
                  alt="Lineage 2 Market Explorer"
                />
                <div>
                  <h3 id="market_explorer">Market Explorer</h3>

                  <p>
                    {t({
                      en: "Simplifies market search and item price tracking.",
                      ru: "Упрощает поиск по рынку и отслеживание цен на предметы.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/rewards.png"
                  alt="Lineage 2 Reward Stats"
                />
                <div>
                  <h3 id="reward_stats">Reward Stats</h3>
                  <p>
                    {t({
                      en: "Information about the extracted Adena, EXP, SP, as well as the number of mobs killed over a certain period of time.",
                      ru: "Информация о добытой АДЕНЕ, ЭКСП, СП, а также о количестве убитых мобов за определенный промежуток времени.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/spoil.png"
                  alt="Lineage 2 Spoil Indicator"
                />
                <div>
                  <h3 id="spoil_indicator">Spoil Indicator</h3>
                  <p>
                    {t({
                      en: "Shows the icon in case of successful completion of the spoiler.",
                      ru: "Показывает иконку в случае успешного прохождения спойла.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img src="/s/hud/icons/chat.png" alt="Lineage 2 Chat" />
                <div>
                  <h3 id="chat">Chat</h3>
                  <p>
                    {t({
                      en: "Adds a custom chat window.",
                      ru: "Кастомное окно чата.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/cp_hp_mp.png"
                  alt="Lineage 2 CP/HP/MP Bar"
                />
                <div>
                  <h3 id="cp_hp_mp">CP/HP/MP Bar</h3>
                  <p>
                    {t({
                      en: "Additional CP,HP and MP panel under the character in the center of the screen.",
                      ru: "Дополнительная панель ЦП, ХП и МП под персонажем в центре экрана.",
                    })}
                  </p>
                </div>
              </div>
              <div className={css.wrap}>
                <img
                  src="/s/hud/icons/autologin.png"
                  alt="Lineage 2 Autologin"
                />
                <div>
                  <h3 id="autologin">Auto-Login</h3>
                  <p>
                    {t({
                      en: "Automatically logged in to the game.",
                      ru: "Автоматически авторизуется в игре.",
                    })}
                  </p>
                </div>
              </div>
            </div>
            <div className="column" style={{ position: "relative" }}>
              <div className={css.sticky}>
                <a href="/addon/get/l2hub-v20.zip" className={css.download}>
                  {t({ en: "Download v20", ru: "Скачать v20" })}
                </a>
                {DEV && <Link to="/subscription">Subscription</Link>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
